import { render, staticRenderFns } from "./BPMNScriptTask.vue?vue&type=template&id=4e777018&"
import script from "./BPMNScriptTask.vue?vue&type=script&lang=js&"
export * from "./BPMNScriptTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports